import { HierarchyContextProps, IHierarchyActionSaveHierarchy } from "../interface";

/**
 * Marks the hierarchy as pending save.
 *
 * @param state - The current hierarchy context state.
 * @param action - The save-hierarchy action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_saveHierarchy = (
  state: HierarchyContextProps,
  action: IHierarchyActionSaveHierarchy,
): HierarchyContextProps => ({
  ...state,
  doSave: true,
  noRedirect: action.noRedirect,
});
